import { PaginatedResponse } from "./paginated-response";

export class Approval {
  status: 'PENDING' | 'DENIED' | 'APPROVED';
  id: string;
  objectID: string;
  authorityUserID: string;
  approvalAllowed: boolean;

}

export class ApprovalUserInput {
  filter: string[] = [];
}

export class PaginatedApprovalResponse extends PaginatedResponse {
  records: Approval[];
}

export class ApprovalReasonInput {
  reason: string;
  denyBack: string;

  constructor() {
    this.reason = null;
    this.denyBack = null;
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/approval.ts